// CONTRACT ADDRESSES FOR FOUNDING FROGGER NFTS

export const FOUNDING_FROG_ADDRESS = "0x4e56f19235ff2a14c76332877a35d6af5bde07ec";
export const FROG_MINTER_ADDRESS = "0xe02f11277cfa84c696370c097c51848c6a6523b3";
